import { useEffect } from "react";

export default function ChatbotLoader() {
  useEffect(() => {
    // Only load chatbot in production mode
    if (process.env.REACT_APP_ENVIRONMENT !== "prod") return;

    const script1 = document.createElement("script");
    script1.src = "https://cdn.botpress.cloud/webchat/v3.3/inject.js";
    script1.defer = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src =
      "https://files.bpcontent.cloud/2025/10/22/10/20251022102743-ED9Y2Q0J.js";
    script2.defer = true;
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  return null;
}
